export const START_SELECTING = '[SELECTION] START_SELECTING';
export const STILL_SELECTING = '[SELECTION] STILL_SELECTING';
export const CHANGE_TABLE_SELECTION = '[SELECTION] CHANGE_TABLE_SELECTION';
export const SELECTION_INITIATE = '[SELECTION] SELECTION_INITIATE';
export const SELECTION_CTRL_PRESSED = '[SELECTION] SELECTION_CTRL_PRESSED';
export const SELECTION_HIGHLIGHT = '[SELECTION] SELECTION_HIGHLIGHT';
export const SELECTION_DROP_HIGHLIGHT = '[SELECTION] SELECTION_DROP_HIGHLIGHT';
